import * as React from 'react';
import { useStores } from 'hooks';
import { observer } from 'mobx-react';

// UI
import { UitkEmptyState } from 'uitk-react-empty-state';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { LocalizedText } from '@shared-ui/localization-context';

// Utils
import { analyticsEvent } from '../util/analytics';

export const ErrorMessagePendingApproval = observer(() => {
  const { analytics, pzStore, userAuth } = useStores();

  React.useEffect(() => {
    if (pzStore?.pzPublisher?.network_status) {
      analyticsEvent(
        analytics,
        userAuth,
        pzStore,
        'affhub.error.pending.presented',
        'Affhub Error Pending Approval Presented',
      );
    }
  }, [userAuth?.currentUserDetails, pzStore?.pzPublisher]);

  return (
    <div className="ErrorMessage__message-container">
      <UitkEmptyState fullscreen={true}>
        <UitkHeading size={3} tag="h2">
          <LocalizedText message="error.pending.heading" />
        </UitkHeading>
        <UitkSpacing margin="four">
          <UitkText size={300} theme="default">
            <LocalizedText message="error.pending.body.text" />
          </UitkText>
        </UitkSpacing>
      </UitkEmptyState>
    </div>
  );
});
